/**
 * Make service call with auto retries on failure.
 * @param serviceCall Service call to be made
 * @param retryAttempts no. of retries to be attempted, defaults to 2.
 * @resolves to serviceCall response, if success
 * @rejects with error, if failed after intended retryAttempts.
 */
export const makeServiceCallWithRetry = async <TResponse>(
    serviceCall: () => Promise<TResponse>,
    retryAttempts: number = 2
): Promise<TResponse> => {
    if (retryAttempts < 0) {
        throw new Error(
            'Invalid retry attempts count passed in params. The count must be non-negative'
        );
    }

    try {
        const response = await serviceCall();
        return response;
    } catch (error) {
        if (!retryAttempts) {
            throw error;
        }
        return makeServiceCallWithRetry(serviceCall, retryAttempts - 1);
    }
};
